// constants
import { TRANSACTION_ID } from './constants';
import {
    SegmentEventButtonNames,
    SegmentEventActionNames,
} from 'utils/segment/constants';

export function getSegmentProps(id: string) {
    if (id === TRANSACTION_ID) {
        return {
            button_name: SegmentEventButtonNames.MY_TRANSACTION,
            action_name: SegmentEventActionNames.CLICK_MY_TRANSACTIONS,
        };
    }
    return {
        button_name: SegmentEventButtonNames.ADD_REMOVE_SUB_DEALER,
        action_name: SegmentEventActionNames.CLICK_ADD_REMOVE_SUB_DEALERS,
    };
}
